import { useCallback, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { useRewardSystemUser } from 'hooks/rewardSystem/useRewardSystemUser';

import { useAcceptTermsMutation } from 'store/api/strapiService/rewardSystemController';

import Loader from 'components/UI/Loader/Loader';
import NotFound from 'components/pages/NotFound/NotFound';
import Banner from 'components/pages/RewardSystem/Banner/Banner';
import Header from 'components/pages/RewardSystem/Header/Header';
import TermsAcceptation from 'components/pages/RewardSystem/Terms/TermsAcceptation/TermsAcceptation';

import styles from './RewardSystem.module.scss';

const RewardSystem = () => {
  const { userId, email, hasAccess, termsAccepted, isLoading } =
    useRewardSystemUser();

  const [acceptTerms, { data: userData, isLoading: termsAccepting }] =
    useAcceptTermsMutation();

  const handleTermsAccept = useCallback(
    () => acceptTerms({ userId }),
    [userId],
  );

  const accepted = useMemo(
    () => termsAccepted || userData?.data?.termsAccepted,
    [termsAccepted, userData],
  );

  if (!email || isLoading) return <Loader />;

  if (!hasAccess) return <NotFound />;

  if (!accepted) {
    return (
      <TermsAcceptation
        onAccept={handleTermsAccept}
        accepting={termsAccepting}
      />
    );
  }

  return (
    <div className={styles.wrapper}>
      <Banner />
      <Header />
      <Outlet />
    </div>
  );
};

export default RewardSystem;
